import { render, staticRenderFns } from "./onDemand_list.vue?vue&type=template&id=2710bf9e&scoped=true&"
import script from "./onDemand_list.vue?vue&type=script&lang=js&"
export * from "./onDemand_list.vue?vue&type=script&lang=js&"
import style0 from "./onDemand_list.vue?vue&type=style&index=0&id=2710bf9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710bf9e",
  null
  
)

export default component.exports